import axios from "axios";

import type {
  IPaginationQueryParams,
  IPaginationResponse,
} from "../common/types";
import type { IAuditLog } from "./types";

export const getListAuditLogs = async (
  lenderCompanyId: number,
  params: IPaginationQueryParams,
) => {
  const response = await axios.get<IPaginationResponse<IAuditLog>>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/audit-logs`,
    {
      params,
    },
  );

  return response.data;
};
